import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { ServicioService, UsuariosService, StorageService } from '../../servicios/index.service';
import { FormGroup, FormControl,Validators } from '@angular/forms';
declare var $;

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {

  datosUsers:any = [];
  formAddUser:FormGroup;
  select:any;
  nvo_user:any;
  valida_datos:any;
  select_t_unidad:any;
  select_t_carga:any;
  checkPermisoF:boolean = false;
  checkPermisoFDos:boolean = true;
  checkRemolque:boolean = false;
  checkRemolqueDos:boolean = true;

  constructor( private _servicio:ServicioService, private _usuarios:UsuariosService,
               private _storage:StorageService, public router:Router) {
    this.acceso();
    this.tabla_users();
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';
    let emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.formAddUser = new FormGroup({
      'user':new FormControl('', [ Validators.required, Validators.maxLength(20),
                                   Validators.minLength(4), Validators.pattern("[a-z]+[0-9]+")] ),
      'nombre':new FormControl('', [ Validators.required, Validators.minLength(3),
                                     Validators.pattern("[a-zA-Z ]*")] ),
      'apellidos':new FormControl('', [ Validators.required, Validators.minLength(3),
                                        Validators.pattern("[a-zA-Z ]*")] ),
      'correo':new FormControl('', Validators.compose([Validators.required, Validators.pattern(emailFormat)])),
      'fecha_nac': new FormControl('', [Validators.required, Validators.pattern("(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}")]),
      'tel': new FormControl('', [Validators.required, Validators.minLength(8),
                                  Validators.pattern('[0-9]*')]),
      'rol':            new FormControl('', [Validators.required]),
      't_unidad':       new FormControl('',),
      'matricula':      new FormControl('',),
      'capacidad':      new FormControl('',),
      'password':       new FormControl('',[Validators.required, Validators.minLength(6),Validators.maxLength(20)]),
      'nom_unidad':     new FormControl(''),
      'num_lic':        new FormControl(''),
      't_unidad_selec': new FormControl(''),
      'v_especializado':new FormControl(''),
      'remolque':       new FormControl(''),
      'remolque_ref':   new FormControl(''),
      'accesorios':     new FormControl(''),
      't_carga':        new FormControl(''),
      't_licencia':     new FormControl(''),
      'modelo':         new FormControl(''),
      'marca':          new FormControl(''),
      'color':          new FormControl(''),
      'permiso_fed_si': new FormControl(''),
      'remolque_check': new FormControl(''),
      't_circ_remolque':new FormControl(''),
      'placas_remolque':new FormControl(''),
      'permiso_fed_text': new FormControl('')

    });
  }

  ngOnInit() {
    this.settime();
  }

  tabla_users(){

    this._usuarios.consulta_users().subscribe(usuarios=>{
        this.datosUsers = usuarios;
        console.log(this.datosUsers);
    });
  }

  acceso(){
    let rol = this._storage.consult_storage('rol');
    if( rol !== "2" && rol !== "account-espe" ){
      this.router.navigate(["/home"]);
    }
  }

  guardar_add_user(){
    let form = this.formAddUser.value;
    console.log(form);

    this.valida_datos = this._usuarios.valida_datos_list( form.user ).map(res=>res).subscribe(data=>{

      if( data.length == 0 ){
        console.log("Form", form.rol);
        if( form.rol == 3 ){

          let datos = {"nombre": form.nombre, "apellidos":form.apellidos, "email":form.correo,
                        "f_naci": form.fecha_nac, "pass":form.password, "rol":form.rol,
                        "tel":form.tel, "img":0, "licencia":form.num_lic,"t_licencia":form.t_licencia,
                        "unidad":{
                                   "c_carga": form.capacidad, "matricula" : form.matricula,
                                   "nom_unidad": form.nom_unidad, "t_unidad": form.t_unidad,"v_especializado": form.v_especializado,
                                   "remolque":form.remolque, "remolque_ref":form.remolque_ref,"accesorios":form.accesorios,
                                   "t_carga":form.t_carga,'modelo':form.modelo,'marca':form.marca, 'color':form.color,
                                   "permiso_fed_si":form.permiso_fed_si,"remolque_check":form.remolque_check,"t_circ_remolque":form.t_circ_remolque,
                                   'placas_remolque':form.placas_remolque,"permiso_fed_text":form.permiso_fed_text
                                 }
                      };



          this.nvo_user = this._servicio.nuevoUser( datos, form.user ).subscribe(data=>{

            let ubicacion = { "lat":0,"lng":0,"servicio":0,"status":0,
                              "status_service":0, "timestam":0 };

            this._servicio.nuevoUbicacion( ubicacion, form.user ).subscribe(data=>{});

            $("#nvo-user").modal('toggle');
            $('#form-add-user').trigger("reset");
              $.notify({
                icon: 'fa fa-user',
                title:"<b>Usuario añadido</b><br>",
                message:"El usuario <b>" + form.user + "</b> se añadió exitosamente"
              });

          },error=>console.log(error));

          //this.nvo_user.unsubscribe();

        }else{
          let datos = { "nombre": form.nombre, "apellidos":form.apellidos, "email":form.correo,
                         "f_naci": form.fecha_nac, "pass":form.password, "rol":form.rol,
                         "tel":form.tel, "img":0
                       };
          this.nvo_user = this._servicio.nuevoUser( datos, form.user ).subscribe(data=>{
            $("#nvo-user").modal('toggle');
            $('#form-add-user').trigger("reset");
            $.notify({
              icon: 'fa fa-user',
              title:"<b>Usuario añadido</b><br>",
              message:"El usuario <b>" + form.user + "</b> se añadió exitosamente"
            });
            console.log(data);
          },error=>console.log(error));

          //this.unsubscribe_user();

        }

      }else{
        //El usuario existe
        $.notify({
          icon: 'fa fa-user',
          title:"<b>Error</b><br>",
          message:"El usuario ya existe"
        });
      }

    });
    //console.log(form);
    this.valida_datos.unsubscribe();

  }

  settime(){
    setTimeout(function(){
      $(function () {
        $("#example1").DataTable();
        $('#example2').DataTable({
          "paging": true,
          "lengthChange": false,
          "searching": false,
          "ordering": true,
          "info": true,
          "autoWidth": false
        });
      });
      console.log("lanzo funcion");
    },2500);
  }

  eliminarUser( id:any ){

    var txt;
    var r = confirm("Estas seguro que deseas eliminar a el usuario " + id + ": El usuario se eliminara por completo.");
    if (r == true) {
      //this.nvo_user.unsubscribe();
      this._servicio.borrarUser( id ).subscribe(data=>{
        this._servicio.borrarUbic( id ).subscribe();
        this._servicio.borrarReg( id ).subscribe();
        if(data == null){
          $.notify({
            icon: 'fa fa-user',
            title:"<b>Se eliminó usuario</b><br>",
            message:"El usuario <b>" +id + "</b> fué eliminado correctamente"
          },{
            type: 'danger'
          });
        }else{
          $.notify({
            icon: 'fa fa-user',
            title:"<b> Ocurrio un error </b><br>",
            message:"El usuario <b>" +id + "</b> no se pudo eliminar"
          },{
            type: 'warning'
          });
        }
      });
    } else {
        txt = "Cancelado!";
    }
  }

  detener_add_user(){
    return this.nvo_user.unsubscribe();
  }

  checkPermidoFFun(){
    if(this.checkPermisoF){
      this.checkPermisoF = false;
      this.checkPermisoFDos = false;
    }else{
      this.checkPermisoF = true;
      this.checkPermisoFDos = false;
    }
  }

  checkPermisoFNo(){
    if(this.checkPermisoFDos){
      this.checkPermisoFDos = false;
      this.checkPermisoF = false;
    }else{
      this.checkPermisoFDos = true;
      this.checkPermisoF = false;
    }
  }
  checkRemolqueFun(){
    if(this.checkRemolque){
      this.checkRemolque = false;
      this.checkRemolqueDos = false;
    }else{
      this.checkRemolque = true;
      this.checkRemolqueDos = false;
    }
  }

  checkRemolqueFunDos(){
    if( this.checkRemolqueDos ){
      this.checkRemolqueDos = false;
      this.checkRemolque = false;
    }else{
      this.checkRemolqueDos = true;
      this.checkRemolque = false;
    }
  }
  prueba(){
    /*
    this._servicio.newUser().subscribe(data=>{
      console.log(data);
    });
    */
  }

  unsubscribe_user(){
    this.nvo_user.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/usuarios/usuarios.component.ts